import {useEffect, useRef} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {
    PROPERTY_FAQ_AB_TEST_ID,
    PROPERTY_FAQ_LOGIN_OPEN_VARIANT,
    PROPERTY_FAQ_NOT_LOGIN_GATED_VARIANT,
    PROPERTY_FAQ_NOT_LOGIN_OPEN_VARIANT,
    propertyFaqAbTest
} from "../../ab_testing/property_faq_ab_test";

interface IPropertyFaqExperiment {
    /** The test has not assigned a variant yet — the FAQ renders a placeholder */
    isResolved: boolean;
    /** The assigned variant renders the FAQ section (`open`/`gated` variants only) */
    isFaqEnabled: boolean;
    /** The assigned variant serves the answers without the registration gate */
    isAnswerGateDisabled: boolean;
    variant: string | null;
}

const OPEN_VARIANTS: string[] = [PROPERTY_FAQ_LOGIN_OPEN_VARIANT, PROPERTY_FAQ_NOT_LOGIN_OPEN_VARIANT];
const FAQ_VARIANTS: string[] = [...OPEN_VARIANTS, PROPERTY_FAQ_NOT_LOGIN_GATED_VARIANT];

export const usePropertyFaqExperiment = (): IPropertyFaqExperiment => {
    const {abTestVariant, canABTestBeRendered} = useABTest({
        id: PROPERTY_FAQ_AB_TEST_ID,
        variants: propertyFaqAbTest.variants,
        pushEventOnlyOnce: true
    });

    // The auth-state split lives in Amplitude targeting — the client only reacts to the assigned variant.
    // Anything outside FAQ_VARIANTS (the `base` variants included) keeps the section hidden.
    const variant = canABTestBeRendered && typeof abTestVariant === "string" && abTestVariant.length > 0 ? abTestVariant : null;

    const hasTrackedExposureRef = useRef(false);

    useEffect(() => {
        if (variant === null || hasTrackedExposureRef.current) {
            return;
        }

        hasTrackedExposureRef.current = true;

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(PROPERTY_FAQ_AB_TEST_ID));
    }, [variant]);

    return {
        isResolved: variant !== null,
        isFaqEnabled: variant !== null && FAQ_VARIANTS.includes(variant),
        isAnswerGateDisabled: variant !== null && OPEN_VARIANTS.includes(variant),
        variant
    };
};
import {useEffect, useRef} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {
    PROPERTY_FAQ_AB_TEST_ID,
    PROPERTY_FAQ_LOGIN_OPEN_VARIANT,
    PROPERTY_FAQ_NOT_LOGIN_GATED_VARIANT,
    PROPERTY_FAQ_NOT_LOGIN_OPEN_VARIANT,
    propertyFaqAbTest
} from "../../ab_testing/property_faq_ab_test";

interface IPropertyFaqExperiment {
    /** The test has not assigned a variant yet — the FAQ renders a placeholder */
    isResolved: boolean;
    /** The assigned variant renders the FAQ section (`open`/`gated` variants only) */
    isFaqEnabled: boolean;
    /** The assigned variant serves the answers without the registration gate */
    isAnswerGateDisabled: boolean;
    variant: string | null;
}

const OPEN_VARIANTS: string[] = [PROPERTY_FAQ_LOGIN_OPEN_VARIANT, PROPERTY_FAQ_NOT_LOGIN_OPEN_VARIANT];
const FAQ_VARIANTS: string[] = [...OPEN_VARIANTS, PROPERTY_FAQ_NOT_LOGIN_GATED_VARIANT];

export const usePropertyFaqExperiment = (): IPropertyFaqExperiment => {
    const {abTestVariant, canABTestBeRendered} = useABTest({
        id: PROPERTY_FAQ_AB_TEST_ID,
        variants: propertyFaqAbTest.variants,
        pushEventOnlyOnce: true
    });

    // The auth-state split lives in Amplitude targeting — the client only reacts to the assigned variant.
    // Anything outside FAQ_VARIANTS (the `base` variants included) keeps the section hidden.
    const variant = canABTestBeRendered && typeof abTestVariant === "string" && abTestVariant.length > 0 ? abTestVariant : null;

    const hasTrackedExposureRef = useRef(false);

    useEffect(() => {
        if (variant === null || hasTrackedExposureRef.current) {
            return;
        }

        hasTrackedExposureRef.current = true;

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(PROPERTY_FAQ_AB_TEST_ID));
    }, [variant]);

    return {
        isResolved: variant !== null,
        isFaqEnabled: variant !== null && FAQ_VARIANTS.includes(variant),
        isAnswerGateDisabled: variant !== null && OPEN_VARIANTS.includes(variant),
        variant
    };
};
